import React from 'react';
import { Flex, NText } from '@fttb/common/components';
import { formatIntoHundredths } from '@fttb/common/utils';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var CardPrice = function CardPrice(_ref) {
  var className = _ref.className,
    oldPrice = _ref.oldPrice,
    price = _ref.price;
  if (!(price !== null && price !== void 0 && price.value)) return null;
  var value = formatIntoHundredths(price.value);
  var oldValue = oldPrice && formatIntoHundredths(oldPrice.value);
  /** Размер шрифта цены уменьшается на порядок для длинных цен (больше 5 символов: '10 000') */
  var valueSize = value.length > 5 ? 'size2-m' : 'size1-m';
  return /*#__PURE__*/React.createElement(Flex, {
    className: cn('container', className),
    "data-t-id": "components-CardPrice"
  }, /*#__PURE__*/React.createElement(NText, {
    size: valueSize,
    "data-t-id": "components-CardPrice"
  }, value), /*#__PURE__*/React.createElement("div", {
    className: cn('rightSide')
  }, oldPrice && /*#__PURE__*/React.createElement(NText, {
    className: cn('old'),
    color: "inherit",
    size: "size5-r-s"
  }, oldValue), /*#__PURE__*/React.createElement(NText, {
    color: "grey60",
    size: "size5-r-s"
  }, price.unit)));
};
var PropTypesPrice = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  unit: PropTypes.string,
  value: PropTypes.number
}) : {};
CardPrice.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  oldPrice: PropTypesPrice,
  price: PropTypesPrice
} : {};